import { cleanseDataBeforeSave } from './cleanseDataBeforeSave';
import { mapToAlertExternalRecipientsChunk, mapToAlertInternalRecipients } from './mapToAlertRecipients';
export const PLACEHOLDER_FOR_SENT_DATE = '${sentDate}';
// this mapping must remain explicit, do not use spread operator, because formData is different object and can contain differently shaped properties
export function mapToApiSaveAlertRequest(formData, userId, secureMessageHint, genericMessage, phinHtmlMessageOptions, stateCode, appTitle, useConsentlessTexting, alertOwners) {
    var _a;
    const alertType = formData.type || 'draft';
    const additionalData = (formData === null || formData === void 0 ? void 0 : formData.additionalData) ? formData.additionalData : {};
    const request = {
        title: formData.title,
        ownerId: formData.ownerId,
        messageType: formData.messageType,
        subject: formData.subject,
        textMessage: formData.textMessage,
        responseOptions: formData.allowResponse ? transformToApiResponseOption(formData.responseOptions) : [],
        channels: formData.channels,
        type: alertType,
        deliveryMode: formData.deliveryOrder.deliveryMode,
        htmlMessage: formData.htmlMessage,
        settings: mapSettings(formData),
        recipients: {
            groups: [],
            contacts: [],
        },
        sendDateTime: formData.sendDateTime ? new Date(formData.sendDateTime).toISOString() : undefined,
        additionalData: Object.assign(Object.assign(Object.assign(Object.assign({}, additionalData), { recipients: JSON.stringify(formData.recipients) }), (formData.customAlertData ? { customAlertData: JSON.stringify(formData.customAlertData) } : {})), (formData.followUp ? { followUp: JSON.stringify(formData.followUp) } : {})),
        emailCc: formData.emailCc,
        icon: formData.icon,
        voiceMessage: formData.voiceMessage,
        voiceMessageType: !formData.channels.includes('voice') ? undefined : formData.voiceMessageType,
        voiceRecordings: !formData.channels.includes('voice') && formData.voiceMessageType !== 'textToVoice' ? undefined : formData.voiceRecordings,
        color: formData.color,
        permissions: formData.permissions ? formData.permissions : undefined,
        phin: formData.phin === true
            ? transformToApiPhinOptions(formData.phin, formData.phinOptions, formData.subject, formData.messageType, phinHtmlMessageOptions, stateCode, appTitle)
            : undefined,
        validityInHours: formData.validityInHours,
        secure: formData.phin ? (_a = formData.phinOptions) === null || _a === void 0 ? void 0 : _a.communicationSensitive : undefined,
        secureMessageHint,
        genericMessage,
        consentless: useConsentlessTexting,
        searchData: formData.searchData,
    };
    return cleanseDataBeforeSave(request, userId, formData.emailAttachments, alertOwners);
}
function mapSettings(formData) {
    var _a, _b;
    const escalationDelay = [];
    if (formData.deliveryOrder.voiceDelay !== undefined) {
        escalationDelay.push({ channel: 'voice', delay: formData.deliveryOrder.voiceDelay });
    }
    if (formData.deliveryOrder.textDelay !== undefined) {
        escalationDelay.push({ channel: 'sms', delay: formData.deliveryOrder.textDelay });
    }
    return {
        escalationDelay: escalationDelay,
        voiceRepeatCount: (_a = formData.voiceOptions) === null || _a === void 0 ? void 0 : _a.repeatTimes,
        voiceRepeatDelay: (_b = formData.voiceOptions) === null || _b === void 0 ? void 0 : _b.waitTime,
    };
}
export function getDeliveryTimeInMinutesLabel(deliveryTimeInMinutes) {
    const hours = Math.floor(deliveryTimeInMinutes / 60);
    const minutes = deliveryTimeInMinutes % 60;
    return ((hours > 0 ? hours + (hours > 1 ? ' hours ' : ' hour ') : '') +
        (minutes > 0 ? minutes + (minutes > 1 ? ' minutes' : ' minute') : ''));
}
export function getAlertInternalRecipients({ internalRecipients, alertChannels, config, context, userFilters, }) {
    return mapToAlertInternalRecipients({ context, internalRecipients, alertChannels, userFilters, config });
}
export function getAlertExternalRecipientsChunk(importId, alertChannels, config, context, limit, offset) {
    return mapToAlertExternalRecipientsChunk(context, importId, alertChannels, limit, offset);
}
function transformToApiResponseOption(responseOptions) {
    return responseOptions
        ? responseOptions.map((option, index) => ({
            optionId: (index + 1).toString(),
            text: option.text,
            conferenceBridgeMeetingId: (option === null || option === void 0 ? void 0 : option.conferenceBridgeMeetingId)
                ? option === null || option === void 0 ? void 0 : option.conferenceBridgeMeetingId.replace(/\s/g, '')
                : undefined,
            conferenceBridgeNumber: option === null || option === void 0 ? void 0 : option.conferenceBridgeNumber,
        }))
        : [];
}
function getPhinDataHtml(params) {
    var _a, _b, _c;
    return `<p><strong>Sensitive</strong>: ${params.phin.communicationSensitive ? 'Yes' : 'No'}</p>
<p><strong>Alert Title</strong>: ${params.subject || ''}</p>
<p><strong>Agency Name</strong>: ${(params === null || params === void 0 ? void 0 : params.appTitle) ? params.appTitle : ''}</p>
<p><strong>Agency Abbreviation</strong>: ${(params === null || params === void 0 ? void 0 : params.stateCode) ? params.stateCode : ''}</p>
<p><strong>Alert Program</strong>: ${(params === null || params === void 0 ? void 0 : params.phinHtmlMessageOptions) && ((_a = params.phinHtmlMessageOptions) === null || _a === void 0 ? void 0 : _a.product) ? params.phinHtmlMessageOptions.product : ''}<br></p>
<p><strong>Unique Identifier</strong>: ${params.phin.uniqueIdentifier || ''}</p>
<p><strong>PHIN Message Type</strong>: ${params.phin.messageType || ''}</p>
<p><strong>Urgency of Event</strong>: ${params.phin.urgencyOfEvent || ''}</p>
<p><strong>Severity of Event</strong>: ${params.phin.severityOfEvent || ''}</p>
<p><strong>Certainty of Event</strong>: ${params.phin.certaintyOfEvent || ''}</p>
<p><strong>Delivery Time</strong>: ${getDeliveryTimeInMinutesLabel(params.phin.deliveryTimeInMinutes || 0)}</p>
<p><strong>Acknowledge this Message</strong>: ${params.phin.recipientAcknowledge ? 'Yes' : 'No'}</p>
<p><strong>Send Time</strong>: ${PLACEHOLDER_FOR_SENT_DATE}</p>
<p><strong>Status</strong>: ${params.messageType || ''}</p>
<p><strong>Reference Alert:</strong></p>
<p><strong>Jurisdiction</strong>: 0</p>
<p><strong>Jurisdiction Level</strong>: ${(params === null || params === void 0 ? void 0 : params.phinHtmlMessageOptions) && ((_b = params.phinHtmlMessageOptions) === null || _b === void 0 ? void 0 : _b.jurisdictionLevel)
        ? params.phinHtmlMessageOptions.jurisdictionLevel
        : ''}</p>
<p><strong>Role</strong>: ${(params === null || params === void 0 ? void 0 : params.phinHtmlMessageOptions) && ((_c = params.phinHtmlMessageOptions) === null || _c === void 0 ? void 0 : _c.productRole) ? params.phinHtmlMessageOptions.productRole : ''}</p>`;
}
function transformToApiPhinOptions(phin, phinOptions, subject, messageType, phinHtmlMessageOptions, stateCode, appTitle) {
    return phin && phinOptions !== undefined
        ? Object.assign(Object.assign({}, phinOptions), { htmlMessage: getPhinDataHtml({
                phin: phinOptions,
                subject,
                messageType,
                phinHtmlMessageOptions,
                stateCode,
                appTitle,
            }) }) : undefined;
}
